

export default function normalizeTemplates(templates) {
  if (!templates) {
    return [];
  }

  return templates.map((template) => ({
    ...template,
    isGlobal: template.isGlobal ? '1' : '2' // re-assigning the value for sorting
  }));
}